<ng-template #content_purchase_entry let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.purchase_entry">
        <div class="side_popup_header">
            <span>{{localService.languageContent.purchase_entry.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 50) + 'px'}" *ngIf="purchaseEntryInitialization">
        <div class="row">
            <div class="col-7" style="text-align: right;padding-right: 0px;">
                <app-label [Text]="localService.languageContent.purchase_entry.ref_num" />
            </div>
            <div class="col-5 en" style="padding-left: 0px;">
                <div style="margin-top: -5px;">
                    <span>{{purchaseEntryInitialization.purchaseEntry.v7}}&nbsp;&nbsp;</span>
                    <button *ngIf="!purchaseEntryInitialization.purchaseEntry.key" class="button_icon button_icon_color"
                        (click)="onLoadRefNumber()" style="top: 6px;">
                        refresh
                    </button>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.title" />
                <input autocomplete="off" type="text" id="{{elementIds.title}}" class="en"
                    [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v3"
                    placeholder="{{localService.languageContent.purchase_entry.title}}"
                    title="{{localService.languageContent.purchase_entry.title}}"
                    (keydown.enter)="localService.onFocusNextInput(elementIds.supplier_dd, 2)" />
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.purchase_entry.entry_type" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="purchaseEntryTypes" [optionValueField]="'key'" [optionTextField]="'value'"
                        placeholder="{{localService.languageContent.purchase_entry.entry_type}}"
                        [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v14" [noAutoComplete]="true"
                        id="{{elementIds.entry_type}}">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.supplier_name" />
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="isSkipSupplier" (change)="onAction(1)" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.skip_supplier}}</span>
                </label>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <div class="search_dd">
                    <ngx-select id="{{elementIds.supplier_dd}}" [disabled]="isSkipSupplier"
                        placeholder="{{localService.languageContent.purchase_entry.select_supplier}}"
                        title="{{localService.languageContent.purchase_entry.select_supplier}}"
                        (typed)="onSearch($event)" [items]="searchItems" [optionValueField]="'key'"
                        [optionTextField]="'v3'" [allowClear]="true" (focus)="onFillSupplierIfEmpty()"
                        (select)="localService.onFocusNextInput(elementIds.invoice_number, 1)"
                        [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v2" (remove)="onRemoveSupplierId(true)">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div class="row" title="{{option.data.v1}}">
                                <div class="col-12">
                                    <div>
                                        <span
                                            [ngClass]="localService.getLanguageCode(option.data.v2)">{{option.data.v1}}</span>
                                    </div>
                                    <div *ngIf="option.data.v5">
                                        <span class="en dim">{{option.data.v5}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                </div>
                <div class="search_scan" *ngIf="!isSkipSupplier">
                    <app-spinner *ngIf="isShowSpinnerCount > 0"
                        style="position: absolute; margin-top: -20px;"></app-spinner>
                    <app-qr-scanner *ngIf="isShowSpinnerCount == 0" style="position: absolute; margin-top: -24px;"
                        (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.invoice_number" />
                <input autocomplete="off" type="text" id="{{elementIds.invoice_number}}" class="en"
                    [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v5"
                    placeholder="{{localService.languageContent.purchase_entry.invoice_number}}"
                    title="{{localService.languageContent.purchase_entry.invoice_number}}"
                    (keydown.enter)="localService.onFocusNextInput(elementIds.way_bill_number, 1)" />
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.way_bill_number" />
                <input autocomplete="off" type="text" id="{{elementIds.way_bill_number}}" class="en"
                    [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v6"
                    placeholder="{{localService.languageContent.purchase_entry.way_bill_number}}"
                    title="{{localService.languageContent.purchase_entry.way_bill_number}}"
                    (keydown.enter)="localService.onFocusNextInput(elementIds.batch_number, 1)" />
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.batch_id" />
                <input autocomplete="off" type="text" id="{{elementIds.batch_number}}" class="en"
                    [(ngModel)]="purchaseEntryInitialization.purchaseEntry.v13"
                    placeholder="{{localService.languageContent.purchase_entry.batch_id}}"
                    title="{{localService.languageContent.purchase_entry.batch_id}}"
                    (keydown.enter)="localService.onFocusNextInput(elementIds.save, 5)" />
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <span *ngIf="message != ''"
                    [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
            <div class="col-4" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(2)">
                    {{id ? localService.languageContent.common.update :
                    localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>